import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IApiResponse } from '../api-response';
import { DataHttpCommonService } from '../data-http-common.service';
import type { IEndpointUrlConfig } from '../endpoint.config';
import { EndpointUrlConfig } from '../endpoint.config';
import {
	DataSourceHttpService,
	IDataSourceGetConfigByEntityCriteria,
	IDataSourceGetConfigByTypeCriteria,
	IDataSourceGetConfigResult,
	IDataSourceGetDataByEntityTypeCriteria,
	IDataSourceGetDataByTypeCriteria,
	IDataSourceGetDataResult,
} from './abstract';

@Injectable()
export class DataSourceHttpServiceImpl implements DataSourceHttpService {
	constructor(
		@Inject(EndpointUrlConfig) public readonly config: IEndpointUrlConfig,
		public readonly http: HttpClient,
		public readonly common: DataHttpCommonService
	) {}

	getConfig<T = any>(criteria: IDataSourceGetConfigByTypeCriteria): Observable<IDataSourceGetConfigResult<T>>;
	getConfig<T = any>(criteria: IDataSourceGetConfigByEntityCriteria): Observable<IDataSourceGetConfigResult<T>>;
	getConfig<T = any>(criteria: any): Observable<IDataSourceGetConfigResult<T>> {
		const id = (criteria as IDataSourceGetConfigByEntityCriteria).id;

		const url = this.common.getApiUrl(
			id ? `data-source/config/${criteria.type}/${id}` : `data-source/config/${criteria.type}`
		);

		return this.http.get<IApiResponse<IDataSourceGetConfigResult<T>>>(url).pipe(map(result => result.data));
	}

	getData<T = any>(criteria: IDataSourceGetDataByTypeCriteria): Observable<IDataSourceGetDataResult<T>>;
	getData<T = any>(criteria: IDataSourceGetDataByEntityTypeCriteria): Observable<IDataSourceGetDataResult<T>>;
	getData<T = any>(criteria: any): Observable<IDataSourceGetDataResult<T>> {
		const id = (criteria as IDataSourceGetConfigByEntityCriteria).id;

		const url = this.common.getApiUrl(
			id ? `data-source/data/${criteria.type}/${id}` : `data-source/data/${criteria.type}`
		);

		return this.http
			.post<IApiResponse<IDataSourceGetDataResult<T>>>(url, criteria.request)
			.pipe(map(result => result.data));
	}
}
